<template>
  <div class="line-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <!-- <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
          :title="request_prefix === 'bigScreen' ? '位置尺寸' : '位置'"
          name="1"
        >
          <div class="setting-item clearFloat">
            <widthAndSizeAndZindex :options="options" :ids="ids" showSetItem="position" />
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="尺寸"
          name="3"
          v-if="request_prefix !== 'bigScreen'"
        >
          <div class="setting-item clearFloat">
            <widthAndSizeAndZindex :options="options" :ids="ids" showSetItem="size" />
          </div>
        </el-collapse-item> -->
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="外观" name="2">
          <div class="content-item mb16">
            <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
          </div>
          <div class="content-item mb16">
            <span class="fs14 mr30">颜色</span>
            <div class="flex1 width170 inlineMiddle">
              <!-- <color-picker-theme-color
                :isThemeColor.sync="bgColorIsThemeColor"
                :color.sync="bgColor"
                class="custom-text-bg"
              /> -->
              <cx-color-picker class="custom-text-bg" :isThemeColor.sync="bgColorIsThemeColor" :colorArr.sync="bgColor">
              </cx-color-picker>
            </div>
          </div>
          <!-- <widthAndSizeAndZindex :options="options" :ids="ids" showSetItem="rotate" class="mb16" v-if="request_prefix !== 'bigScreen'" /> -->
          <div class="content-item mb16">
            <span class="fs14 mr30">粗细</span>
            <div class="flex1 width170 inlineMiddle">
              <single-input
                class="cx_style"
                :value.sync="borderWidth"
                inputSuffixs="px"
              />
<!--              <el-input-->
<!--                class="cx_style"-->
<!--                v-model="borderWidth"-->
<!--                placeholder="请输入"-->
<!--                v-inputHandle="{ this1, type: 'borderWidth', env: request_prefix }"-->
<!--                type="number"-->
<!--                @focus="getFocus($event)"-->
<!--              >-->
<!--                <template slot="suffix">-->
<!--                  <span class="suffix_text">px</span>-->
<!--                </template>-->
<!--              </el-input>-->
            </div>
          </div>
          <div class="border-select inlineMiddle mb16">
            <span class="fs14 mr30">类型</span>
            <el-select
              class="flex1 width170"
              :value="chineseLineName"
              placeholder="请选择"
              popper-class="border-option"
              @change="changeType"
              ref="borderStyleSelect"
            >
              <el-option v-for="item in borderStyleList" :key="item.value" :label="item.label" :value="item.value">
                <div>
                  <span class="selected-icon" :class="lineType === item.value ? 'icon-portal-check-small' : ''"></span>
                  <span class="border-style" :style="getBorderStyle(item)"></span>
                  <span>{{ item.label }}</span>
                </div>
              </el-option>
            </el-select>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"

export default {
  name: "line-options-data",
  components: { widthAndSizeAndZindex, controlWidthAndSizeAndZindex },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      this1: this,
      collapseActiveNames: ["1", "2", "3"],
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          bigScreenSrc: require("../../../assets/images/solid-1.png"),
          portalSrc: require("../../../assets/images/solid-2.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          bigScreenSrc: require("../../../assets/images/dashed-1.png"),
          portalSrc: require("../../../assets/images/dashed-2.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          bigScreenSrc: require("../../../assets/images/dotted-1.png"),
          portalSrc: require("../../../assets/images/dotted-2.png")
        }
        // {
        //   value: "double",
        //   label: "双实线",
        //   title: "",
        //   portalSrc: require("../../../assets/images/double-solid-1.png")
        // },
        // {
        //   value: "doubleDotted",
        //   label: "双虚线",
        //   title: "",
        //   portalSrc: require("../../../assets/images/double-dashed-1.png")
        // }
      ],
      chineseLineName: undefined
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? this.options.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    rotate: {
      get() {
        return parseInt(this.options.rotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rotate", false)
      }
    },
    lineType: {
      get() {
        return this.options.hasOwnProperty("lineType") ? this.options.lineType : "solid"
      },
      set(newVal) {
        if (newVal.indexOf("double") > -1 && this.borderWidth === 1) {
          this.borderWidth = 3
        }
        this.$changeOptionsEV(newVal, "lineType", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.hasOwnProperty("borderWidth") ? this.options.borderWidth : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    getBorderStyle() {
      let _this = this
      return function (item) {
        let src = _this.request_prefix === "bigScreen" ? item.bigScreenSrc : item.portalSrc
        return {
          "background-image": `url(${src})`
        }
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "bgColorIsThemeColor", "bgColorIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    }
  },
  mounted() {
    this.changeLineName()
  },
  methods: {
    getFocus(event) {
      event.currentTarget.select()
    },
    changeType(val) {
      this.lineType = val
      this.$nextTick(() => {
        this.changeLineName()
      })
    },
    changeLineName() {
      const item = this.borderStyleList.find(it => it.value === this.lineType)
      const _chineseLineName = item.label //获取边线的中文名
      const inputInner = this.$refs.borderStyleSelect.$el.getElementsByClassName("el-input__inner")[0] //input框的dom
      const inputWidth = inputInner.offsetWidth //input框宽度
      const computedStyle = window.getComputedStyle(inputInner)
      const inputFontSize = Number(computedStyle.getPropertyValue("font-size").slice(0, -2)) //input框的fontsize
      const textWidth = _chineseLineName.length * inputFontSize //文字宽度
      this.chineseLineName = _chineseLineName //修改input框的value，这个value由空格和文字组成

      //-----------------------input框文字逻辑处理完毕
      //2.input框的背景图（线条图）处理逻辑
      let src = this.request_prefix === "bigScreen" ? item.bigScreenSrc : item.portalSrc
      inputInner.style.backgroundImage = "url(" + src + ")"
      //4表示的是文字和背景图的右边距，8代表箭头右边距，16表示的是箭头
      inputInner.style.backgroundPosition = `-${216 - inputWidth + textWidth + 4 + 8 + 16}px center`
    }
  }
}
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.border-select {
  width: 100%;
}
.mr30 {
  margin-right: 30px;
}
.width170 {
  width: 170px;
}
.selected-icon {
  position: absolute;
  top: 50%;
  left: 8px;
  font-size: 14px;
  color: var(--themeColor);
  transform: translateY(-50%);
}
.border-style {
  display: inline-block;
  width: 107px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
  background-position: left center;
  background-clip: content-box;
}
.border-select ::v-deep .el-select {
  background: var(--inputBackGround);
  border-radius: 4px;
}
.border-select ::v-deep .el-select:hover {
  background: var(--inputNuberHoverThemeBgColor);
}
.border-select ::v-deep .el-input .el-input__inner {
  text-align: right;
  padding-right: 28px;
  display: block;
  border: none !important;
  background-repeat: no-repeat;
  background-clip: content-box;
}
.border-option .el-scrollbar__view li {
  &:nth-child(n + 3) {
    .border-style {
      background-size: contain;
      background-repeat: no-repeat;
      padding-left: 8px;
    }
  }
}
</style>
